export enum ButtonType {
  Green,
  White,
}
